module.exports = __webpack_public_path__ + "img/logo_golf_col_white.ad764f96.png";